
<img (click)="changeActif(!isActif)" [src]="isActif ? '../assets/svg/actif_on.svg' : '../assets/svg/actif_off.svg'">
